import { eventCategories, eventRegions, eventTags, eventStatusList } from "@/mocks/events";

export interface FilterValues {
  category: string;
  region: string;
  dateRange: string;
  status: string;
  tags: string[];
}

interface FilterPanelProps {
  values: FilterValues;
  dateRanges: string[];
  onChange: (patch: Partial<FilterValues>) => void;
  onReset: () => void;
}

function OptionGroup({
  title,
  options,
  value,
  onSelect,
}: {
  title: string;
  options: string[];
  value: string;
  onSelect: (next: string) => void;
}) {
  return (
    <div className="border-b border-background-200 px-5 py-4 last:border-b-0">
      <h4 className="mb-3 font-heading text-sm font-bold text-foreground-950">{title}</h4>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => onSelect(option)}
            className={`whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
              value === option
                ? "bg-primary-500 text-background-50"
                : "bg-background-100 text-foreground-700 hover:bg-background-200"
            }`}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterPanel({
  values,
  dateRanges,
  onChange,
  onReset,
}: FilterPanelProps) {
  const toggleTag = (tag: string) => {
    const next = values.tags.includes(tag)
      ? values.tags.filter((item) => item !== tag)
      : [...values.tags, tag];
    onChange({ tags: next });
  };

  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-filter-3-line text-primary-600"></i>
          筛选条件
        </h3>
        <button
          type="button"
          onClick={onReset}
          className="whitespace-nowrap text-xs font-medium text-foreground-500 transition-colors hover:text-accent-600"
        >
          重置
        </button>
      </div>

      <OptionGroup
        title="赛事类型"
        options={eventCategories}
        value={values.category}
        onSelect={(next) => onChange({ category: next })}
      />
      <OptionGroup
        title="举办地区"
        options={eventRegions}
        value={values.region}
        onSelect={(next) => onChange({ region: next })}
      />
      <OptionGroup
        title="举办时间"
        options={dateRanges}
        value={values.dateRange}
        onSelect={(next) => onChange({ dateRange: next })}
      />
      <OptionGroup
        title="赛事状态"
        options={eventStatusList}
        value={values.status}
        onSelect={(next) => onChange({ status: next })}
      />

      <div className="px-5 py-4">
        <h4 className="mb-3 font-heading text-sm font-bold text-foreground-950">热门标签</h4>
        <div className="flex flex-wrap gap-2">
          {eventTags.map((tag) => {
            const active = values.tags.includes(tag);
            return (
              <button
                key={tag}
                type="button"
                onClick={() => toggleTag(tag)}
                className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                  active
                    ? "bg-accent-500 text-foreground-950"
                    : "bg-secondary-100 text-secondary-800 hover:bg-secondary-200"
                }`}
              >
                {active && <i className="ri-check-line"></i>}
                {tag}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}